import React from "react"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { BLOCKS } from "@contentful/rich-text-types"

import { Indent } from "src/uikit"
import { getModalClickHandler } from "src/components/ModalsContainer/events"

import * as S from "./styled"

const options = {
  renderNode: {
    // eslint-disable-next-line react/display-name
    [BLOCKS.PARAGRAPH]: (node, children) => {
      return <S.Description>{children}</S.Description>
    },
  },
}

const Content = ({ title, json, btnName, modalType, modalTitle, url }) => {
  const toggleModal = getModalClickHandler(modalType, { title: modalTitle })

  return (
    <S.Container>
      <S.Title className="title">{title}</S.Title>
      <Indent lg={16} md={16} sm={16} />
      {documentToReactComponents(json, options)}
      {!modalType && !url && <Indent lg={24} md={24} sm={16} />}
      {btnName && modalType && (
        <S.Button type="button" onClick={toggleModal}>
          <span>{btnName}</span>
        </S.Button>
      )}
      {btnName && url && (
        <S.Button as="a" href={url}>
          <span>{btnName}</span>
        </S.Button>
      )}
    </S.Container>
  )
}

const Case = props => {
  const isExternalLink = props.url ? props.url.includes("http") : false

  if (!props.url) {
    return <Content {...props} />
  }

  return isExternalLink ? (
    <S.Link href={props.url} target="_blank" rel="noopener noreferrer">
      <Content {...props} />
    </S.Link>
  ) : (
    <S.InnerLink to={props.url}>
      <Content {...props} />
    </S.InnerLink>
  )
}

export default Case
